import { Service } from '../Service';
export default class RemoteUpdateService extends Service {
    constructor(axios) {
        super(axios);
    }
}
